import React from 'react';
import { createRoot } from 'react-dom/client';

import ImpossiblePanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const createImpossibleScreen = ({ loginLink }) => {
  const root = createRoot(document.getElementById('impossiblePanel'));
  if (isSupportedBrowser()) {
    root.render(
      <AuthScreenLayout>
        <ImpossiblePanel loginLink={loginLink} />
      </AuthScreenLayout>
    );
  } else {
    root.render(<UnsupportedBrowsers />);
  }
};

window.createImpossibleScreen = createImpossibleScreen;
